import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import pages from '../routes';

export default React.memo(({ children, roles, groups }) => {
  const { data: user } = useSelector((state) => state.user);

  const userRole = roles.some((x) => x.includes(user?.roles));
  const userGroup = groups.some((pageGroup) => user?.userGroup.some(group => pageGroup.includes(group)));
  const userRoute = pages.find(
    (page) => page.roles.includes(user?.roles) && page.groups.some(group => user?.userGroup.includes(group)),
  );

  return !userRole || !userGroup ? (
    <Navigate to={`/dashboard/${userRoute?.path ? userRoute?.path : ''}`} />
  ) : (
    children
  );
});
